<template>
  <div
    :id="content.idHTML"
    :class="[jel_getClassObject(content), content.theme ? content.theme : 'themeClair']"
    class="entete-section position-relative couleur-section-debut"
    :style="{
      '--couleurSection': content.couleurSection,
      '--couleurSectionDebut': content.couleurSectionDebut,
    }"
  >
    <div :class="content.imagePleineLargeur === 'true' ? 'contenu-pleine-largeur' : 'contenu'">
      <div class="position-relative img-gradient mx-auto image mb-2">
        <MediaImageFocalPoint :content="contentMediaImage" />
        <b-row class="restreindre-largeur m-auto">
          <div class="boite-texte mx-md-auto px-2 pl-sm-3 px-xl-4">
            <div
              class="texte-information position-relative"
              :class="
                content.theme
                  ? content.theme == 'themeClair'
                    ? 'themeFonce'
                    : 'themeClair'
                  : 'themeFonce'
              "
            >
              <Titre :content="contentSurTitre" />
              <p class="titre-entete pb-0 mb-1" v-html="content.titre" />
              <div class="sous-titre" v-html="content.sousTitre" />
              <span @click.capture="gaPreventClick">
                <Hyperlien :content="contentBouton" />
              </span>
            </div>
          </div>
        </b-row>
      </div>
      <div v-if="content.afficherDegrade == 'true'" class="degrade position-absolute w-100" />
    </div>
    <div
      class="couleur-section"
      :class="{ 'restreindre-largeur': content.restreindreLargeur === 'true' }"
    >
      <EditableArea
        :content="content.enteteSection"
        :parentTemplateId="metadata['mgnl:template']"
      />
    </div>
  </div>
</template>

<script>
import { gtmCustomEventByVendor } from '@/helpers/ConsentHelpers';

import { EditableArea } from '@/vue-editor';
import Titre from '@/components/base/Titre';
import Hyperlien from '@/components/base/Hyperlien';
import MediaImageFocalPoint from '@/components/media/image/MediaImageFocalPoint';

export default {
  name: 'EnteteSection',
  components: { Titre, Hyperlien, MediaImageFocalPoint, EditableArea },
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  computed: {
    contentMediaImage() {
      return {
        formatRatio: this.content.imagePleineLargeur === 'true' ? '16x9' : '4x3',
        image: this.content.image,
      };
    },
    contentSurTitre() {
      return {
        type: 'grandTitre',
        titre: this.content.surTitre,
        classeCSS: this.content.cacherSurTitre == 'true' ? 'sr-only' : 'p-0',
      };
    },
    contentBouton() {
      return {
        texte: this.content.libBouton,
        type: 'boutonSecondaire',
        lien: this.content.lien,
        classeCSS: 'm-0 p-0',
      };
    },
  },
  methods: {
    gaPreventClick(event = null) {
      const evt = 'ga-es-click';
      const categorie = 'ES - Entete Section';
      const emplacement = this.jel_gaGetEmplacement();

      // Calcul de la position de l'EnetetSection dans la liste des EnteteSection du DOM
      let position = 1;
      // Récupère la liste des 'entete-section' du DOM
      const elements = Array.from(document.getElementsByClassName('entete-section'));
      const titre = this.content.titre.trim();
      if (elements) {
        const indexElement = elements.findIndex((element, index) => {
          if (element.innerText.split('\n').includes(titre)) {
            // Fix pour sortir si index = 0
            return index + 1;
          }
          return null;
        });
        position = indexElement + 1;
      }
      const libelle = this.jel_libelleLienGoogleAnalytics(this.content.lien);
      if (libelle) {
        gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
          event: evt,
          categorie,
          emplacement,
          libelle,
          position,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.entete-section {
  margin: auto;
}

.boite-texte {
  .themeFonce {
    background: $noir-casino;
    color: $couleur-blanc;
  }
  .themeClair {
    background: $couleur-blanc;
    color: $couleur-bleu-fonce-lq;
  }
}
.texte-information {
  border-radius: 1.5rem;
  padding-top: 24px;
  padding-right: 16px;
  padding-left: 16px;
  padding-bottom: 24px;
  z-index: 1;
  ::v-deep {
    h1 {
      font-size: $font-size-4;
      line-height: $line-height-4;
      font-family: graphik_medium;
      margin-bottom: 4px;
      width: 60%;
    }
    .btn {
      margin-bottom: 0;
      font-size: $font-size-6;
      line-height: $line-height-5;
    }
  }
}
.titre-entete {
  font-size: $font-size-11;
  letter-spacing: $letter-spacing-n1;
  line-height: $line-height-13;
  font-family: graphik_super;
  margin-bottom: 0.75rem;

  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.contenu {
  overflow: hidden;
  .image {
    max-width: 1600px;
    ::v-deep img {
      object-fit: contain;
      object-position: right;
    }
  }
}

.contenu-pleine-largeur {
  overflow: hidden;
  .image {
    ::v-deep img {
      object-fit: cover;
      object-position: center;
    }
  }
}
.img-gradient {
  overflow: hidden;

  &.restreindre-largeur {
    max-width: unset;
    .img-gradient.image-pleine-largeur {
      max-width: 1600px;
    }
  }
}

@include media-breakpoint-down(xs) {
  .contenu {
    .img-gradient {
      &::v-deep img {
        object-position: right -34px !important;
      }
    }
    .degrade {
      height: 105vw;
    }
  }
  .contenu-pleine-largeur {
    .img-gradient {
      > div:first-child {
        position: relative;
      }

      ::v-deep img {
        object-fit: cover;
        object-position: right -25px !important;
        height: 300px !important;
      }
    }
    .degrade {
      height: 400px !important;
    }
  }

  .boite-texte {
    width: 100%;
    margin-top: -14vw;
    margin-bottom: 16px;
  }
  .degrade {
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 30%, var(--couleurSection) 62.5%);
  }
}
@include media-breakpoint-up(sm) {
  .contenu {
    height: 65vw;
    .img-gradient {
      height: 70vw !important;
      ::v-deep img {
        object-position: right -50px;
      }
    }
    .degrade {
      height: 70vw;
    }
    .boite-texte {
      position: absolute;
      bottom: 60px;
      width: 50%;
    }
  }
  .contenu-pleine-largeur {
    .img-gradient {
      height: 50vw !important;
      ::v-deep {
        .focal-point {
          height: 100%;
        }
        img {
          margin: 0 !important;
        }
      }
    }
    .degrade {
      height: 52.5vw !important;
    }
    .boite-texte {
      position: absolute;
      bottom: 3vw;
      width: 50%;
    }
  }
  .degrade {
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 45%, var(--couleurSection) 87.5%);
  }
}
@include media-breakpoint-up(md) {
  .titre-entete {
    font-size: $font-size-12;
    line-height: $line-height-16;
  }
  .contenu {
    height: 50vw;
    .img-gradient {
      margin-top: -3.5vw;
      margin-bottom: 2vw;
      height: 50vw !important;
      ::v-deep img {
        object-position: right -25px;
      }
    }
    .degrade {
      height: 50vw;
    }
    .boite-texte {
      bottom: 5vw;
      width: 42%;
    }
  }
  .contenu-pleine-largeur {
    .img-gradient {
      height: 42.5vw !important;
    }
    .degrade {
      height: 45vw !important;
    }
    .boite-texte {
      bottom: 2vw;
      width: 42%;
    }
  }
}
@include media-breakpoint-up(lg) {
  .contenu {
    height: 37.5vw;
    .img-gradient {
      height: 40vw !important;
      ::v-deep img {
        object-position: right -10px;
      }
    }
    .degrade {
      height: 40vw;
    }
    .boite-texte {
      bottom: 3vw;
    }
  }
  .contenu-pleine-largeur {
    .img-gradient {
      height: 35vw !important;
    }
    .degrade {
      height: 40vw !important;
    }
  }
}
@include media-breakpoint-up(xl) {
  .contenu {
    .img-gradient {
      ::v-deep img {
        object-position: right -10px;
      }
    }
    .boite-texte {
      width: 38%;
    }
  }
  .contenu-pleine-largeur {
    .img-gradient {
      height: 32.5vw !important;
    }
    .degrade {
      height: 37.5vw !important;
    }
  }
}
@media (min-width: 1600px) {
  .contenu {
    height: 600px;
    .img-gradient {
      height: 650px !important;
      margin-top: -60px;
    }
    .degrade {
      height: 650px;
    }
  }
  .contenu-pleine-largeur {
    .img-gradient {
      height: 550px !important;
    }
    .degrade {
      height: 625px !important;
    }
  }
  .contenu,
  .contenu-pleine-largeur {
    .boite-texte {
      bottom: 25px;
      width: 600px;
    }
  }
}
.degrade {
  content: '';
  top: 0;
}
.couleur-section {
  background-color: var(--couleurSection);
}
.couleur-section-debut {
  background-color: var(--couleurSectionDebut);
}

.themeFonce {
  ::v-deep .libelle-liste {
    a {
      color: $blanc-casino !important;
    }
  }
}
::v-deep {
  .grandTitre {
    font-size: 13px;
    line-height: 14px;

    @include media-breakpoint-up(sm) {
      font-size: 14px;
      line-height: 16px;
    }
  }
}

.sous-titre {
  font-size: 15px;
  line-height: 18px;
  ::v-deep p {
    padding-bottom: 16px;
  }
}
</style>
